import FoodView from './FoodView';
import MenuView from './MenuView';
import MenuConfirm from './MenuConfirm';
import MenuItem from './MenuItem';
import MenuOrder from './MenuOrder';
import MenuSummary from './MenuSummary';
import MenuHeader from './MenuHeader';
import OldMenu from './OldMenu';
import OrdersHistory from './OrdersHistory';
import OrderHistoryPage from './OrderHistoryPage';
import HistoryTable from './HistoryTable';

export {
    MenuHeader, FoodView, MenuView, MenuSummary, MenuOrder, MenuItem, MenuConfirm,
    OldMenu, OrderHistoryPage, OrdersHistory, HistoryTable
};



/** WEBPACK FOOTER **
 ** ./src/modules/food/index.js
 **/